export const changePass = {
    spinnerContainer: `flex w-full justify-center items-center container`,
    outerContainer: `flex flex-col pt-5 pb-[25px] px-4 bg-themeShadowColor border-[primaryButton] rounded-[10px] w-full max-w-[unset] md:max-w-[500px] gap-2
                     sm:px-[30px]   
    `,
    header: `flex flex-col gap-1`,
    heading: `text-[22px] font-[500]
              sm:text-[25px]
    `,
    subHeading: `text-[13px] text-[#c4c0c0]
                 sm:text-[14px]
    `,
    info: `flex flex-col px-[10px] md:px-3 py-3 gap-1 border-[1px] border-gray-600 rounded-[10px]`,
    infoHeading: `text-[16px] sm:text-[18px] font-[400]`,
    infoText: `text-[12px] sm:text-[14px] font-[400]`,
    form: `flex flex-col gap-5 pt-3`,
    inputFields: `flex flex-col gap-6 pb-2`,
}
